/* eslint-disable import/prefer-default-export */
export { default as UserMenu } from './UserMenu';
//# sourceMappingURL=index.js.map